module.exports = __webpack_public_path__ + "static/media/Smart Lighting.d659a22b.png";